import React, { useEffect, useState } from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import HistoryOutlined from "@mui/icons-material/HistoryOutlined";
import { getMovements } from "../../../services/CongeService";

const TYPES = {
    acquis: { label: "Acquis", color: "#166534", bg: "#f0fdf4", sign: "+" },
    consommation: { label: "Congé posé", color: "#b91c1c", bg: "#fef2f2", sign: "−" },
    restitution: { label: "Restitution", color: "#0369a1", bg: "#f0f9ff", sign: "+" },
    ajustement: { label: "Ajustement", color: "#b45309", bg: "#fffbeb", sign: "±" },
    report: { label: "Report", color: "#5b21b6", bg: "#f5f3ff", sign: "+" },
};

const fmtDate = (d) => {
    if (!d) return "";
    const date = new Date(d);
    return isNaN(date) ? d : date.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
};

export default function MovementsList({ collaborateurId, year, height = 280 }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!collaborateurId || !year) return;
        setLoading(true);
        getMovements(collaborateurId, year)
            .then(({ data }) => setRows((data || []).slice(-50).reverse()))
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    }, [collaborateurId, year]);

    if (!collaborateurId) return null;

    return (
        <Box sx={{ borderRadius: "14px", background: "#fff", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(15,23,42,0.05)", p: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
                <Box sx={{ width: 34, height: 34, borderRadius: "9px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ebf4fb", color: "#03407b" }}>
                    <HistoryOutlined sx={{ fontSize: 19 }} />
                </Box>
                <Typography sx={{ fontSize: "0.95rem", fontWeight: 800, color: "#0f172a" }}>Historique {year}</Typography>
                {rows.length > 0 && <Typography sx={{ ml: "auto", fontSize: "0.75rem", color: "#94a3b8" }}>{rows.length} mouvement{rows.length > 1 ? "s" : ""}</Typography>}
            </Box>

            <Box sx={{ maxHeight: height, overflowY: "auto", pr: 0.5 }}>
                {loading ? (
                    [0, 1, 2].map((i) => <Skeleton key={i} variant="rounded" height={44} sx={{ mb: 0.75, borderRadius: "10px" }} />)
                ) : rows.length === 0 ? (
                    <Box sx={{ py: 4, textAlign: "center", color: "#94a3b8" }}>
                        <HistoryOutlined sx={{ fontSize: 30, mb: 0.5 }} />
                        <Typography sx={{ fontSize: "0.85rem" }}>Aucun mouvement en {year}.</Typography>
                    </Box>
                ) : (
                    rows.map((r, i) => {
                        const t = TYPES[r.type] || { label: r.type, color: "#475569", bg: "#f1f5f9", sign: "" };
                        return (
                            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1.25, py: 0.9, borderBottom: i < rows.length - 1 ? "1px solid #f1f5f9" : "none" }}>
                                <Box sx={{ minWidth: 52, textAlign: "center", px: 0.75, py: 0.4, borderRadius: "8px", background: t.bg, color: t.color, fontWeight: 800, fontSize: "0.85rem" }}>
                                    {t.sign}{Math.abs(Number(r.nbJours) || 0)} j
                                </Box>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography sx={{ fontSize: "0.86rem", fontWeight: 600, color: "#0f172a" }}>{t.label}</Typography>
                                    <Typography sx={{ fontSize: "0.74rem", color: "#64748b" }}>
                                        {r.periodeDebut ? `Du ${fmtDate(r.periodeDebut)} au ${fmtDate(r.periodeFin)}` : fmtDate(r.date)}
                                    </Typography>
                                </Box>
                                {r.periodeDebut && (
                                    <Typography sx={{ ml: "auto", fontSize: "0.72rem", color: "#94a3b8" }}>{fmtDate(r.date)}</Typography>
                                )}
                            </Box>
                        );
                    })
                )}
            </Box>
        </Box>
    );
}
